import {Component, OnDestroy, OnInit} from '@angular/core';
import {Website} from "../website";
import {ActivatedRoute} from '@angular/router';
import {User} from "../../../user/user";
import {filter} from "rxjs/operators";
import {DbResponse} from "../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../shared/components/notifier/notification";
import {NotificationType} from "../../../shared/components/notifier/notification-type";
import {WebsiteService} from "../../website.service";
import * as fromStore from "../../../store";
import {ActivityAction, IActivity} from "../../../activities/activity";
import {Observable, Subscription} from "rxjs";
import {Store} from "@ngrx/store";
import {Product} from "../product";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {HostingService} from "../hosting/hosting.service";

@Component({
    selector: 'db-ten-webx',
    templateUrl: './tenWebX.component.html',
    styleUrls: ['./tenWebX.component.scss'],
    standalone: false
})
export class TenWebXComponent implements OnInit, OnDestroy {
  public website: Website;
  public user: User;
  public tenWebX: any;
  public loading: boolean;
  public ongoingActivity$: Observable<IActivity>;
  public ongoingBuilderActivities$: Observable<IActivity>;
  public builderPlugin: Product;
  public builderPluginResolver: Product;
  public elementorPlugin: Product;
  public elementorPluginResolver: Product;
  private subscriptions: Subscription[];
  private loadingMessage: any;
  public formSubmitted: boolean;
  public layoutMap: FormControl;

  constructor(
    private _route: ActivatedRoute,
    private _websiteService: WebsiteService,
    private _hostingService: HostingService,
    private _store: Store<fromStore.DbStoreState>
  ) {
  }

  ngOnInit() {
    this.elementorPluginResolver = this._route.snapshot.data['elementorPlugin'];
    this.elementorPlugin = this.elementorPluginResolver;
    this.builderPluginResolver = this._route.snapshot.data['builderPlugin'];
    this.builderPlugin = this.builderPluginResolver;
    this.layoutMap = new FormControl(false);
    this.tenWebX = new FormGroup({
      'websiteUrl': new FormControl('', [Validators.required]),
      'magicInput': new FormControl(''),
      'layoutMap': this.layoutMap
    });
    this.formSubmitted = false;

    this.user = this._route.snapshot.parent.data['user'];

    this.website = this._route.snapshot.parent.data['website'];
    this.ongoingActivity$ = this._store.select(fromStore.getAiCreateWebsiteOngoingActivity(this.website.id));
    this.ongoingActivity$.subscribe((activity: IActivity) => {
    });
    this.addEventHandlers();
  }

  public ngOnDestroy(): void {
    this.removeEventHandlers();
  }

  public changeWebsiteUrl(): void {
    this.tenWebX.controls.websiteUrl.setValue( (<HTMLTextAreaElement>document.getElementById("tenWebxWebsiteUrl")).value );
    this.tenWebX.controls.magicInput.setValue( (<HTMLInputElement>document.getElementById("tenWebxMagicInput")).value );
  }

  private addEventHandlers(): void {
    this.subscriptions = [];
    this.ongoingBuilderActivities$ = this._store.select(fromStore.getBuilderOngoingActivity(this.website.id, this.builderPlugin.slug, !!this.website.domain_hash));
    this.ongoingBuilderActivities$.subscribe((activity: any) => {
      if (activity)  {
        if (activity.status && (activity.status === 'done' || activity.status === 'failed')) {
          if(activity.status === 'done') {
            this._hostingService.clearCache( this.website.id );
          }
          this.loading = false;
        }
        else {
          this.loading = true;
        }
      }
    });
    this.subscriptions.push(this._store.select(fromStore.getWebsiteElementorPlugin(this.website.id)).subscribe((elementorProduct: Product) => {
      if (elementorProduct) {
        this.elementorPlugin = elementorProduct ? elementorProduct : this.elementorPluginResolver;
      }
    }));

    this.subscriptions.push(this._store.select(fromStore.getWebsiteBuilderPlugin(this.website.id)).subscribe((builderProduct: Product) => {
      if (builderProduct) {
        this.builderPlugin = builderProduct ? builderProduct : this.builderPluginResolver;
      }
    }));
    this.subscriptions.push(this._store.select(fromStore.getWebsitePlugins(this.website.id)).subscribe((plugins: Product[]) => {
      if (this.elementorPlugin && this.elementorPlugin.active && this.builderPlugin && this.builderPlugin.active && this.loading) {
        this.loading = false;
      }
    }));
  }

  private removeEventHandlers(): void {
    this.subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
    this.subscriptions = null;
  }

  public runTenWebX () {
    this.formSubmitted = true;
    this.changeWebsiteUrl();
    if (this.tenWebX.valid) {
      this.loading = true;
      this._websiteService.runTenWebX(this.website.id, this.tenWebX.value)
        .pipe(
          filter((response: DbResponse): boolean => !!response)
        )
        .subscribe((response: DbResponse): void => {
          this.loading = false;

          if (!response.success) {
            NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
          }
        });
    }

  }

  public installAndActivate(): void {
    this.loading = true;
    this.loadingMessage = "Enabling 10Web Builder";
    this._store.dispatch(new fromStore.InitWebsiteProductAction({
      website: this.website,
      products: [this.elementorPlugin, this.builderPlugin],
      action: ActivityAction.INSTALL_ACTIVATE,
      network: 1 // TODO DISCUSS
    }));
  }
}
